export default __webpack_public_path__ + "static/media/avatar_tommy2.d30d5ff8.mp3";